import axios from '@axios'

const getInitialState = () => ({
  cities: [],
  formCalendar: {
    id: null,
    name: null,
    startDate: null,
    endDate: null,
    description: null,
    type: null,
    provinces: [],
    cities: [],
    purchaseFactor: null,
    stores: [],
  },
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {
    
  },

  mutations: {
    SET_CALENDAR(state, calendar) {
      state.formCalendar = { ...calendar }
    },
    SET_CITIES(state, { data }) {
      state.cities = data
    },
    CLEAN_STATE(state) {
      const { formCalendar } = getInitialState()
      state.formCalendar = formCalendar
    },
  },

  actions: {
    async fetchCalendar({ commit }, id) {
      const { data } = await axios.get(`/api/seasonal-calendar/${id}`)
      console.log('Dados do calendário recebido:', data)
      
      // Mapear os dados da API para o formato esperado pelo formulário
      const mappedCalendar = {
        ...data,
        provinces: Array.isArray(data.states) 
          ? data.states.map(state => state.idIbge.toString())
          : [],
        cities: Array.isArray(data.cities) 
          ? data.cities.map(city => city.idIbge.toString())
          : [],
        stores: Array.isArray(data.stores) 
          ? data.stores.map(store => store.id.toString())
          : []
      }
      
      // Remover os campos de origem após transformação
      delete mappedCalendar.states
      
      commit('SET_CALENDAR', mappedCalendar)
    },
    async setCities({ commit }, cities) {
        if (!Array.isArray(cities)) return
        commit('SET_CITIES', { data: cities })
    },
    async saveCalendar({ state }) {
        console.log('Salvando calendário com dados:', state.formCalendar)
      
      // Transformar arrays de IDs em objetos com a estrutura esperada pelo DTO
      const calendarData = {
        ...state.formCalendar,
        states: Array.isArray(state.formCalendar.provinces) 
          ? state.formCalendar.provinces.map(provinceId => ({ idIbge: parseInt(provinceId, 10) }))
          : [],
        cities: Array.isArray(state.formCalendar.cities) 
          ? state.formCalendar.cities.map(cityId => ({ idIbge: parseInt(cityId, 10) }))
          : [],
        stores: Array.isArray(state.formCalendar.stores) 
          ? state.formCalendar.stores.map(storeId => ({ id: parseInt(storeId, 10) }))
          : []
      }
      
      // Remover os campos de origem após transformação
      delete calendarData.provinces
      delete calendarData.city
      
      await axios({
        method: state.formCalendar.id ? 'PUT' : 'POST',
        url: '/api/seasonal-calendar',
        data: calendarData
      })
    },
    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
